import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ThumbSourceFactoryService } from '../../../../../shared/services/thumb-source-factory.service';

@Component({
    selector: 'account-orders-details-items-item',
    templateUrl: './account.orders.details.items.item.component.html',
    styleUrls: ['./../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersDetailsItemsItemComponent {
    @Input('item') item;

    constructor(
        protected thumbFactory: ThumbSourceFactoryService
    ) {}



    /**
     * Check Component Tag
     * @param item
     */
    public hasTagComponente(item: any): boolean {
        if (!item || !item.item || typeof item.item.tags !== 'object') {
            return false;
        }

        for (const key in item.item.tags) {
            if (item.item.tags[key].slug === 'componente') {
                return true;
            }
        }

        return false;
    }

    /**
     * @param source
     */
    public getThumbSource(source: string) {
        return this.thumbFactory.make(source, 56, 70);
    }
    /**
     * Item extra fields length is greater than zero.
     **/
    public hasExtraFields(item): boolean {
        return Object.keys(item.extra_fields).length > 0;
    }
    /**
     * Get extra fields and values from item's extra fields.
     **/
    public getExtraFields(item) {
        return Object
            .keys(item.extra_fields)
            .map(slug => item.extra_fields[slug]);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/account/orders/details/items/item/account.orders.details.items.item.component.ts